<template>
    <main-block>
        <main-title class="page__title_between">
            <div class="dashboard-title page__title_mb12"> 
                Calendar 

                <router-link 
                    class="main-btn main-btn_green main-btn_ml"
                    :to="{name: `Results`, params: {
                        id: $route.query.id
                    }, query: {
                        name: $route.query.db_schema
                    }}"
                > 
                    Charts
                </router-link>
            </div> 
             
            <template v-if="showDate">
                <el-date-picker 
                    type="date" 
                    placeholder="Pick a date"
                    v-model="activeDate"   
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" 
                    class="calendar-datepicker"
                    :pickerOptions="pickerOptions"
                    @change="changeDate"
                ></el-date-picker>
            </template> 
        </main-title> 
        
        <main-breadcrumbs  
            :links="links"
            v-if="breadcrumbs"
            class="breadcrumbs_bb"
        />
       
        <!-- CALENDAR HEAD ITEM START  --> 
        <calendar-head-item/>
        <!-- CALENDAR HEAD ITEM END  -->

        <!-- CALENDAR LIST ITEM START  -->
        <calendar-list-item 
            :items="items"
            :is-visible="show"
        />
        <!-- CALENDAR LIST ITEM END  -->
    </main-block>
</template>

<script> 
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'; 
import calendarListItem from '@/components/lists/calendar/ListItem';
import calendarHeadItem from '@/components/lists/calendar/HeadItem';

export default {
    name: 'calendar-schedule', 
    components: {
        calendarListItem,
        calendarHeadItem
    },
    data() {
        return { 
            links: [
                {
                    id: 1,
                    title: 'Main',
                    url: '/'
                },
                {
                    id: 2,
                    title: 'History',
                    url: '/history'
                },
                {
                    id: 3,
                    title: 'Calendar'
                }
            ],
            form: {}, 
        }
    },
    computed: {
        ...mapState({
            date: 'calendar/activeDate'
        }),
        ...mapGetters({
            items: 'calendar/items', 
            pickerOptions: 'calendar/pickerOptions',
            showDate: 'calendar/showDate', 
            breadcrumbs: 'calendar/showBreadcrumbs',
            show: 'calendar/show', 
        }), 
        activeDate: {
            get() { return this.$store.state.calendar.activeDate; },
            set(value) { 
                this.setState({
                    key: 'activeDate',
                    value
                });  
            }
        }
    },
    methods: {
        ...mapActions({
            fetch: 'calendar/get'
        }),
        ...mapMutations({
            setState: 'calendar/setState'
        }),
        prepareToFetch(time) {
            const date = new Date(time); 
            date.setDate(date.getDate());
            date.setHours(12);
            
            const day =  date.getTime() / 1000; 
            const id = this.$route.query.id;
            const db_schema = this.$route.query.db_schema;

            this.setState({
                key: 'activeDate',
                value: time
            });   
            return {day, id};
        },
        prepareDatePicker() { 
            const first_day = this.$route.query.first_day;
            const last_day = this.$route.query.last_day;  
          
            this.setState({
                key: 'pickerOptions',
                value: {
                    disabledDate(time) { 
                        const from = new Date(first_day);  
                        const till = new Date(last_day);  
                        
                        return  time.getTime() > till || time.getTime() < from.getTime() - 8.64e7 ;
                    }
                } 
            });
        },
        toggleDatePicker() { 
            this.setState({
                key: 'showDate',
                value: true
            });
        },
        toggleView() { 
            this.setState({
                key: 'show',
                value: true
            });
        },
        showBreadcrumbs() {
            this.setState({
                key: 'showBreadcrumbs',
                value: true
            }); 
        },
        async changeDate(value) {
            const {day, id} = this.prepareToFetch(value);
            await this.fetch({day, id});
        }
    }, 
    async mounted() {  
        this.prepareDatePicker(); 
        this.toggleDatePicker(); 
        this.showBreadcrumbs();

        const {day, id, db_schema} = this.prepareToFetch(this.$route.query.first_day);
        await this.fetch({day, id});
        this.toggleView(); 
    }
}
</script>

<style lang="scss">
.dashboard-title {
    display: flex;
    align-items: center;
} 

.calendar-day__item {
    width: calc(100% + 15px);
    overflow-x: hidden;
    overflow-y: scroll;
}

.row {
    height: 80px;
    display: flex;
    border-bottom: solid 1px #f3f3f3;
    position: relative;

    &__name {
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgba(#4d4d4d, 0.5);
        // font-family: $fontMedium;
        font-size: 16px;
        width: 250px; 
        background-color: #fff;
        z-index: 9;  
        // @include respond(desktop) {
        //     font-size: 14px;
        // }
    }

    &__times {
        position: relative;
        width: calc( 100% - 500px);
        display: flex;
        overflow: hidden;

        & .time {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(100% / 12);
            color: rgba(#4d4d4d, 0.5);
            // font-family: $fontMedium;
            font-size: 16px;
            border-left: 1px solid #e0e0e0;
            box-sizing: border-box;
            min-width: 45px;
            // @include respond(desktop) {
            //     min-width: 39px;
            //     font-size: 13px;
            // }

            &:last-child {
                // border-right: 1px solid #e0e0e0;
            }
        }
 
    }

    &--new {
        cursor: pointer;

        & .row__name {
            justify-content: flex-start;
            border-top: 1px solid #71bd4a;
            padding-left: 16px;
            box-sizing: border-box;
            color: #4d4d4d;
            font-size: 10px;
            z-index: 9;

            & img {
                margin-right: 10px;
                width: 24px;
            }
        }

        & .time span {
            display: block;
            width: 100%;
            height: 100%;
            background-color: rgba(#71bd4a, 0.1);
        }

        & .request {
            position: absolute;
            top: 9px;
            height: 30px;
            border-radius: 8px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
            background-color: #71bd4a;
            color: #ffffff;
            font-size: 12px;
            // font-family: $fontBold;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            width: 40px;
        }
    }

    &--service {
        height: 78px; 

        & .row__name {
            border-top: 1px solid #979797;
            justify-content: flex-start;
            padding-left: 16px;
            box-sizing: border-box;
            color: #4d4d4d;
            font-size: 10px;

            & img {
                margin-right: 10px;
                width: 24px;
            }
        }

        & .line {
            position: absolute;
            display: inline-block;
            height: 7px;
            cursor: pointer;
            transition: 0.5s;

            &:hover {
                transform: scale(1.2);
                height: 7px;
            }
        }
    }

    &--image {
        width: 30px;
        height: 30px;
        border: solid 1px grey;
        background-size: cover;
        background-position: center;
        border-radius: 50%;
        margin-right: 10px;
        flex-shrink: 0;
    }

    &__stats {
        width: 250px;  
        border-left: 1px solid #e0e0e0;
        display: flex;
        align-items: center;
    }
}

.master {
    &-schedule {
        width: 100%; 
        height: 48px;
        background-color: rgba(155, 205, 130, 0.3);
        position: absolute;
        left: 0;
        top: calc(50% - 23px); 
    }

    &-online { 
        background-color: #8336fe8c;
        position: absolute; 
        bottom: 0;
        z-index: 4; 
        height: 0.6vh;   
        // border-bottom: 2px solid #502D8C; rgb(52, 147, 255)
    }

    &-break {
        background-color: #ff9800;
        position: absolute; 
        bottom: 0;
        z-index: 5; 
        height: 0.6vh;  
        // border-bottom: 2px solid red ff9800;
    }

    &-roads { 
        &__item {
            // background-color: rgb(52, 147, 255);
            position: absolute; 
            bottom: 0;
            z-index: 5; 
            height: 0.6vh; 
            color: white;
            background: repeating-linear-gradient(
                45deg,
                #0000ffba,
                #0000ffba 10px,
                rgb(52, 147, 255) 10px,
                rgb(52, 147, 255) 20px
            );
        }   
    }

    &-order {
        cursor: pointer; 
        background-color: rgba(#50AF3C, 1);
        position: absolute;
        top: 16px;
        bottom: 18px;
        z-index: 1;
 
        &__actual {
            background-color: rgba(#50AF3C, 0.9);  
            position: absolute; 
            width: 100%;
            height: 100%;
        }

        &__late {
            right: 0;
            width: 10%;
            height: 100%;
            background-color: red;
            position: absolute;
            top: 0;

            &-end {
                background-color: rgba(247,109,104,0.8);
            }
        }
    }

    &-orders_span {
        position: absolute;
        right: 5px;
        z-index: 999;
        top: 5px;
        font-size: 10px;
        border: 1px solid #000;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%; 
    }
}

.statistic {
    display: flex;
    height: auto;
    justify-content: center;
    align-items: flex-end;
    background-color: #fff;
    z-index: 4;
    
    &-item {
        display: flex;
        flex-direction: column;
        width: 22px;
        margin: 9px 0;
        height: calc(100% - 18px);

        &:not(:last-child) {
            margin-right: 35px;
        }

        &_text {
            color: rgba(77, 77, 77, 0.8);
            font-size: 11px;
        }

        &__p {
            &_ok {
                color: #FFC100;
            }

            &_bad {
                color: #FF3100;
            }

            &_so-so {
                color: #F07300;
            }

            &_good {
                color: #9BCD82; 
            }

            &_awesome {
                color: #3493FF;
            }
        }

        &__box {
            height: 90%;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            
            &_actual { 
                width: 100%;
                background-color: #FFC100;
            }

            &_online { 
                width: 100%;
                background-color: #9BCD82; 
            }

            &_execution { 
                width: 100%;
                background-color: #3493FF; 
            } 

            &_orders {
                width: 100%; 
            }

            div {
                max-height: 100%;
            }
        }

        p {
            height: 10%;   
            margin: 0;
            margin-top: 5px;
        }
    } 
}

.statistic-item_text {
    font-size: 9px;
}

.row__stats {
    display: flex;
    align-items: center;  
}

.statistic_head {
    .statistic-item {
        height: auto !important; 
    }
}

.statistic-item { 
    flex-direction: column;
    width: 20%;
    margin: 9px 0;
    height: calc(100% - 18px);
    text-align: center;

    &:last-child {
        word-break: break-word;
    }

    p {
        font-size: 11px;
    }
}

.statistic-item:not(:last-child) {
    margin-right: 12px;
}  
</style>
